export default __webpack_public_path__ + "static/O0212-d02e0f6cce1479b2afc67577e8f9ab35.png";